export default __webpack_public_path__ + "static/media/reference_img03.21777e6b.png";